    import React from 'react';
import CommodityCardMinimal from '../CommodityCard/CommodityCardMinimal';

const ShopEvents = ({
    isEventsLoaded,
    validEvents,
    cartCount,
    onAdd,
    onOpenModal,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onMouseMove
}) => {
    return (
        <>
            {/* اسکلتون شیمر رویدادها در زمان بارگذاری اولیه */}
            {!isEventsLoaded && (
                <div className="events-container">
                    {[1, 2].map((n) => (
                        <div className="skeleton-event-section" key={`sk-ev-${n}`}>
                            <div className="event-header-custom">
                                <div className="event-line" />
                                <div className="skeleton-event-header skeleton-shimmer" />
                                <div className="event-line" />
                            </div>
                            <div className="skeleton-event-row">
                                {[1, 2, 3].map((m) => (
                                    <div className="skeleton-minimal-card" key={`sk-min-${m}`}>
                                        <div className="skeleton-minimal-img skeleton-shimmer" />
                                        <div className="skeleton-line title skeleton-shimmer" style={{ margin: '0 auto' }} />
                                        <div className="skeleton-line subtitle skeleton-shimmer" style={{ margin: '0 auto' }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* رویدادهای دارای کالا */}
            {isEventsLoaded && validEvents.length > 0 && (
                <div className="events-container">
                    {validEvents.map((event, index) => (
                        <div className="event-section" key={event.id || index}>
                            <div className="event-header-custom">
                                <div className="event-line" />
                                <span className="event-title-custom">{event.title}</span>
                                <div className="event-line" />
                            </div>
                            {event.description && (
                                <span className="event-subtitle-custom">{event.description}</span>
                            )}
                            <div
                                className="event-commodities-wrapper custom-scroll-area"
                                onMouseDown={onMouseDown}
                                onMouseLeave={onMouseLeave}
                                onMouseUp={onMouseUp}
                                onMouseMove={onMouseMove}
                            >
                                {event.commodities.map((item) => (
                                    <div className="event-commodity-item" key={item.id}>
                                        <CommodityCardMinimal
                                            commodity={item}
                                            onAdd={onAdd}
                                            badge={cartCount}
                                            onOpenModal={() => onOpenModal(item.id)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default React.memo(ShopEvents);
